import { render, staticRenderFns } from "./QrMenuPagePdf.vue?vue&type=template&id=533c4564&scoped=true"
import script from "./QrMenuPagePdf.vue?vue&type=script&lang=js"
export * from "./QrMenuPagePdf.vue?vue&type=script&lang=js"
import style0 from "./QrMenuPagePdf.vue?vue&type=style&index=0&id=533c4564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c4564",
  null
  
)

export default component.exports